export const css = {
    root: '_3Y2VjzlR',
    includePostAndPracticeTest: '_2qHpFyT5',
    includePostTest: '_186t6s4e',
    ptHeader: '_2h51YSje',
    action: 'c0nA9i7E',
    statusIcon: '_6iXLSRJt',
    completed: '_2NyDGO1q',
    ptAssess: '_2E7V_30s',
    ptStudyPath: 'mCye2G2n',
    studyPathLabelBar: '_2Ji_99rR',
    studyPathLabel: '_3T4jntAE',
    studyPathLabelLine: '_3knS4TGz',
    ptExam: '_3Vh3UuGJ',
    ptExamDate: '_3VduWgdn',
    setExamDate: '_2-JzL1km',
    examDate: 'n2R8ogwP',
    ptPostTest: '_1MrqGGy6',
    studypath: '_1YGf_p79',
    next: '_3csNJI1H',
    active: '_18x-iUDH',
    statusLine: '_3oDkBiYQ',
    notComplete: 'CBfld5lw',
    ' _key': 'dashboard-widgets/progress-tracker'
};
export default css;
